import { render, staticRenderFns } from "./InvoiceRecipientAddresses.vue?vue&type=template&id=6b70a1e6&scoped=true&"
import script from "./InvoiceRecipientAddresses.vue?vue&type=script&lang=js&"
export * from "./InvoiceRecipientAddresses.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceRecipientAddresses.vue?vue&type=style&index=0&id=6b70a1e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b70a1e6",
  null
  
)

export default component.exports